import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { AccountStatusComponent } from './account-status.component';
import { PayOnLineComponent } from './pay-on-line/pay-on-line.component';
import { StatusComponent } from './status/status.component';
import { AccountStatusRoutingModule } from './account-status-routing.module';
import { SharedModule } from '../../shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    AccountStatusRoutingModule,
    SharedModule
  ],
  declarations: [AccountStatusComponent, PayOnLineComponent, StatusComponent]
})
export class AccountStatusModule { }



// WEBPACK FOOTER //
// /app/src/app/office/account-status/account-status.module.ts